//todo: fix hilite scroll on mobile landscape

<template>
  <div class="hilite-wrap">
    <h1 v-if="player.contentType == 'event'">Event HiLites</h1>
    <h1 v-else>More HiLites</h1>
    <div
      class="hilite-scroll-wrap"
      :class="[useScroll == true ? 'enable-scroll' : '']"
    >
      <div class="scroll-inner" ref="scrollInner">
        <div
          class="hilite"
          v-for="hilite in hilites"
          :key="hilite.title"
          :style="{ backgroundImage: `url(${hilite.thumbnail})` }"
          v-on:click="loadHilite(hilite)"
        >
          <h4>{{ hilite.title }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HiLitesSidebar",
  data: function() {
    return {
      useScroll: false
    };
  },
  computed: {
    hilites() {
      return this.$store.state.hilites;
    },
    player() {
      return this.$store.state.player;
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkForScroll);
    this.checkForScroll(true);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkForScroll);
  },
  methods: {
    loadHilite(hilite) {
      this.$store.commit("setHiLite", hilite);
    },
    checkForScroll(callImmediately) {
      let that = this;

      function checkScroll(that) {
        if (
          window.innerHeight - that.$refs.scrollInner.offsetTop <
          that.$refs.scrollInner.scrollHeight
        ) {
          that.useScroll = true;
        } else {
          that.useScroll = false;
        }
      }

      if (callImmediately) checkScroll(that);

      window.clearTimeout(that.scrollTimeout);

      that.scrollTimeout = window.setTimeout(function() {
        checkScroll(that);
      }, 100);
    }
  }
};
</script>

<style lang="stylus" scoped>
.hilite-wrap
  width: 100%
  margin-bottom: 50px
  @media screen and (max-width: mobile-landscape)
    margin-bottom: 0px
.hilite-scroll-wrap
  margin-top: 30px
  @media screen and (max-width: mobile-landscape)
    margin-top: 15px
  &.enable-scroll
    height: calc(100vh - 300px)
    overflow-y: scroll
    @media screen and (max-width: mobile-landscape)
      height: auto
      overflow: visible
h1
  fluid font-size 28 20
  font-family: "montserrat"
  font-weight: bold
  color: #001249
  margin: 0px
.hilite
  width: 100%
  padding-top: 56.25%;
  margin-bottom: 20px
  position: relative
  background-size: auto 200%
  background-position: center center
  cursor: pointer
  @media screen and (max-width: mobile-landscape)
    margin-bottom: 10px
  &:after
    content: ""
    position: absolute
    bottom: 0px
    left: 0px
    width: 100%
    height: 60px
    background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(35,35,35,0.75) 100%);
  h4
    position: absolute
    margin: 0px
    left: 20px
    bottom: 10px
    fluid font-size 16 14
    color: #FFF
    z-index: 5
.empty-hilites
  padding: 20px
  background: #e5e5e5
</style>
